import {useEffect, useState} from 'react';

import {useOverallInfo} from '@components/_context/UserOverallInfo';
import {getActiveShippingAddressWithFallback} from '@helpers/userAddressLogistics';

type ShippingAddressInfo = {
  address?: Record<string, unknown>;
  delivery?: {courier?: string | null; pickupId?: string | null; pickupName?: string | null};
};

const useActiveShippingAddress = (): ShippingAddressInfo => {
  const {id: userId, shippingAddress = {}} = useOverallInfo();
  const [activeShippingAddress, setActiveShippingAddress] = useState<ShippingAddressInfo>(shippingAddress);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const result = await getActiveShippingAddressWithFallback({userId, shippingAddress});
      if (!cancelled) {
        setActiveShippingAddress(result);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userId, shippingAddress]);

  return activeShippingAddress;
};

export {useActiveShippingAddress};
